export var RedemptionType;
(function (RedemptionType) {
    RedemptionType["CASH"] = "cash";
    RedemptionType["ITEM"] = "item";
    RedemptionType["EXPERIENCE"] = "experience";
    RedemptionType["GACHA"] = "gacha";
})(RedemptionType || (RedemptionType = {}));
export var RedemptionStatus;
(function (RedemptionStatus) {
    RedemptionStatus["PENDING"] = "pending";
    RedemptionStatus["APPROVED"] = "approved";
    RedemptionStatus["PROCESSING"] = "processing";
    RedemptionStatus["COMPLETED"] = "completed";
    RedemptionStatus["CANCELLED"] = "cancelled";
    RedemptionStatus["EXPIRED"] = "expired";
})(RedemptionStatus || (RedemptionStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9pbnRSZWRlbXB0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL25la28tc3RhZmYvUG9pbnRSZWRlbXB0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBTixJQUFZLGNBS1g7QUFMRCxXQUFZLGNBQWM7SUFDeEIsK0JBQWEsQ0FBQTtJQUNiLCtCQUFhLENBQUE7SUFDYiwyQ0FBeUIsQ0FBQTtJQUN6QixpQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFMVyxjQUFjLEtBQWQsY0FBYyxRQUt6QjtBQUVELE1BQU0sQ0FBTixJQUFZLGdCQU9YO0FBUEQsV0FBWSxnQkFBZ0I7SUFDMUIsdUNBQW1CLENBQUE7SUFDbkIseUNBQXFCLENBQUE7SUFDckIsNkNBQXlCLENBQUE7SUFDekIsMkNBQXVCLENBQUE7SUFDdkIsMkNBQXVCLENBQUE7SUFDdkIsdUNBQW1CLENBQUE7QUFDckIsQ0FBQyxFQVBXLGdCQUFnQixLQUFoQixnQkFBZ0IsUUFPM0IifQ==